import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";

export default function NavBarConditionalComponent() {
  const location = useLocation();

  if (location.pathname.startsWith("/editor/")) {
    return null;
  }

  return <Navbar />;
}
